import dynamic from 'next/dynamic'
import { useRouter } from 'next/router'

// ** React Imports
import React, { useState, useEffect } from 'react'

// import Fade from '@mui/material/Fade'

//  ** ant design
import { Empty } from 'antd'
import UploadOutlined from '@ant-design/icons/UploadOutlined'

//  ** MUI
import CardBlogReViewItemList from './CardBlogReViewItemList'

// import BlogReViewItemList from './BlogReViewItemList'
import CircularProgress from '@mui/material/CircularProgress'
import TablePagination from '@mui/material/TablePagination'

// ** MUI Imports
import Grid from '@mui/material/Grid'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'

import { styled } from '@mui/material/styles'

// Redux
import { connect } from 'react-redux'
import { compose } from 'redux'
import { toggleLayoutLoginModal } from 'src/@core/redux/actions'

// ** Icons Imports

//  ** Utils
import isEmpty from 'lodash/isEmpty'
import { useTranslation } from 'next-i18next'

//  ** Constants
import { PAGINATION, EMPTY_DATA_ID } from '../../../constants/Constants'

const ButtonStyled = styled(Button)(({ theme }) => ({
  [theme.breakpoints.down('sm')]: {
    width: '100%',
    textAlign: 'center'
  }
}))

const BlogReviewDataList = props => {
  const { t } = useTranslation()

  // ** State
  const [totalItem, setTotalItem] = useState(0)
  // ** Modal
  const [visibleBlogDetail, setVisibleBlogDetail] = useState(false)
  // eslint-disable-next-line no-unused-vars
  const [dataBlogDetail, setDataBlogDetail] = useState(null)
  // ** Hook
  const router = useRouter()

  function calculateTotalItem() {
    let number = 0
    if (!isEmpty(props.counterData)) {
      number = props.counterData.numberItemAll
      setTotalItem(number)
    }
  }

  useEffect(() => {
    calculateTotalItem()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.counterData])

  const handleChangePage = (event, page) => {
    const newPage = page + 1
    props.onChangePage(newPage)
  }

  const handleChangeRowsPerPage = event => {
    props.onChangeRowsPerPage(parseInt(event.target.value, PAGINATION.REVIEW))
  }

  const handleClickItem = blogInfo => {
    if (props.isOpenPageDetail === true) {
      const path = `/ielts-review/${blogInfo.slug}`
      router.push({
        pathname: path
      })
    } else {
      setDataBlogDetail({ ...blogInfo, editing: false })
      setVisibleBlogDetail(true)
    }
  }

  // eslint-disable-next-line no-unused-vars
  const handleClickAction = (blogInfo, type) => {
    if (props.onClickActions) {
      props.onClickActions(blogInfo, type)
    }
  }

  const handleClickAddNew = () => {
    if (isEmpty(props.dbUser)) {
      props.toggleLayoutLoginModal(true)
    } else {
      setDataBlogDetail({ _id: EMPTY_DATA_ID, editing: true })
      setVisibleBlogDetail(true)
    }
  }

  function handleCancelBlogWriting() {
    setVisibleBlogDetail(false)
  }

  return (
    <Grid container spacing={6}>
      <Grid item xs={12}>
        <Typography variant='h5'>{props.title}</Typography>
        <Typography variant='body2'>{props.subTitle}</Typography>
      </Grid>
      {props.needAdd === true && (
        <Grid item xs={12}>
          <Box sx={{ pt: 0, width: '100%' }}>
            <ButtonStyled
              component='label'
              variant='contained'
              htmlFor='account-settings-upload-image'
              startIcon={<UploadOutlined />}
              onClick={handleClickAddNew}
            >
              {t('general.write_your_review')}
            </ButtonStyled>
          </Box>
        </Grid>
      )}
      {props.dataList.length > 0 ? (
        props.dataList.map((reviewItemData, reviewItemIndex) => (
          <CardBlogReViewItemList
            needBadge={props.needBadge}
            needAction={props.needAction}
            key={reviewItemData._id}
            isFeedback={props.isFeedback}
            itemData={reviewItemData}
            itemIndex={reviewItemIndex}
            onClickAction={handleClickAction}
            onClickItem={handleClickItem}
          />
        ))
      ) : props.loading === true ? (
        <Box sx={{ pt: 8, width: '100%' }}>
          <CircularProgress
            color='inherit'
            sx={{
              marginLeft: 6
            }}
          />
        </Box>
      ) : (
        <Box sx={{ p: 2, width: '100%' }}>
          <Empty description={<span>{t('general.no_data_to_display')}</span>} />
        </Box>
      )}
      {/* </Grid> */}

      <Grid item xs={12} sx={{ paddingBottom: 4, width: '100%' }}>
        <TablePagination
          component='div'
          count={totalItem}
          page={props.currentPage - 1}
          rowsPerPage={props.rowsPerPage}
          rowsPerPageOptions={[]}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Grid>
      {visibleBlogDetail === true && (
        <ModalBlogWriting
          visible={visibleBlogDetail}
          itemInfo={dataBlogDetail}
          zIndex={2000}
          onCancel={handleCancelBlogWriting}
        />
      )}
    </Grid>
  )
}

const ModalBlogWriting = dynamic(() => import('src/@core/layouts/components/modal/modal_blog_writing'))

export function mapDispatchToProps(dispatch) {
  return {
    toggleLayoutLoginModal: value => dispatch(toggleLayoutLoginModal(value))
  }
}

const withConnect = connect(null, mapDispatchToProps)

export default compose(React.memo, withConnect)(BlogReviewDataList)
